import {LitElement, html} from 'lit';
import {createRef, ref} from 'lit/directives/ref.js';
import styles from './x-installation-terms.component.scss?as=stylesheet';
import {proformaStore} from 'extensions/proforma/data/proforma-store';

export class InstallationTerms extends LitElement {

	checkbox = createRef();

	static styles = [styles];

	static get properties () {
		return {
			isHidden: {
				type: Boolean
			},
			section: {
				type: String
			},
			terms: {
				type: String
			}
		};
	}

	constructor () {
		super();

		this.isHidden = true;
		this.terms = '';
		this.section = '';
		this.checked = false;
	}

	determineVisibility () {
		if (!this.section) {
			return true;
		}

		const selected = [];

		for (const key of Object.keys(proformaStore?.state ?? {})) {
			for (const selection of proformaStore.state[key]) {
				if (!selection.code) {
					continue;
				}

				selected.push(selection.code);
			}
		}

		return selected.findIndex(element => element === this.section) > -1;
	}

	determineValidity () {
		if (this.isHidden === false) {
			if (!this.checkbox?.value?.checked) {
				this.registerTerms();
			}
		} else {
			this.sendValidTerms();
			if (this.checkbox?.value) {
				this.checkbox.value.checked = false;
			}
			this.requestUpdate();
		}
	}

	handleCheck (e) {
		if (e.target.checked === true) {
			this.sendValidTerms();
		} else {
			this.determineValidity();
		}
	}

	registerTerms () {
		const options = {
			required: 1,
			section: this.section + '_terms'
		};

		this.dispatchEvent(new CustomEvent('section_render', {
			bubbles: true,
			composed: true,
			detail: options
		}));
	}

	sendValidTerms () {
		const options = {
			required: 1,
			section: this.section + '_terms'
		};

		this.dispatchEvent(new CustomEvent('terms_valid', {
			bubbles: true,
			composed: true,
			detail: options
		}));
	}

	connectedCallback () {
		super.connectedCallback();

		// Check on initialization
		this.isHidden = !this.determineVisibility();

		window.addEventListener('option_click', () => {
			this.isHidden = !this.determineVisibility();
			this.determineValidity();
		});

		this.determineValidity();
	}

	disconnectedCallback () {
		window.removeEventListener('option_click');

		super.disconnectedCallback();
	}

	render () {
		return html`
			<label class="installation-terms" ?hidden="${this.isHidden}">
				<input type="checkbox" name="agree" class="checkbox" @change="${(e) => this.handleCheck(e)}" ${ref(this.checkbox)}/>
				<span class="caption">${this.terms}</span>
			</label>
		`;
	}
}

customElements.define('x-installation-terms', InstallationTerms);
